import { DESKTOP_SCALE_FACTOR, MOBILE_SCALE_FACTOR, TABLET_SCALE_FACTOR } from './constants'

export const getScaleFactor = (containerWidth) => {
    if (containerWidth < 768) return MOBILE_SCALE_FACTOR

    if (containerWidth < 1024) return TABLET_SCALE_FACTOR

    return DESKTOP_SCALE_FACTOR
}

export const getInitScale = () => {
    if (window.innerWidth < 600) {
        return 0.45
    }
    return 1
}

export const getInitXPosition = () => {
    if (window.innerWidth < 600) {
        return 25
    }
    return 0
}

// Returns hall seating but with replaced group seats (normally as two seats - replaced with only one seat which is on the left)
export const transformMovieSeating = (data) => {
    const prices = data?.prices
    const seats = data?.seats
    const descriptions = data?.descriptions
    const entrances = data?.entrances

    const transformedSeats = seats?.reduce((acc, seat) => {
        const seatGroupId = seat?.group_seatid
        const seatId = seat?.seatid

        // Return all non-double seats
        if (seatGroupId === 0) return [...acc, seat]

        // Figure out if the group seat is already in accumulator
        // If the seat is already present do not add it again
        if (acc.find((s) => s?.group_seatid === seatGroupId)) return acc

        // Figure out which seat is other in the pair
        const groupSeat = seats.find((s) => s?.group_seatid === seatGroupId && s?.seatid !== seatId)

        // Return the left seat and change it size (will be shown as double)
        if (groupSeat?.x1 < seat?.x1) {
            groupSeat.x2 = seat.x2
            groupSeat.y2 = seat.y2
            return [...acc, groupSeat]
        }
        seat.x2 = groupSeat.x2
        seat.y2 = groupSeat.y2
        return [...acc, seat]
    }, [])

    const output = {
        prices,
        seats: transformedSeats,
        descriptions,
        entrances,
    }

    return output
}
